import React, {useContext} from "react";
import PropTypes from "prop-types";
import {Redirect, Route} from "react-router-dom";
import JString from "@easytech-international-sdn-bhd/jstring";
import AppContext from "../Services/AppContext";
import {isMerchandiser, isPromoter} from "../Helper/Helper";

const MODULE_PROTECTED_ROUTES = {
	'/main/manageusers': 'manageusers',
	'/main/competitor': 'competitor',
	'/main/competitorgallery': 'competitor',
	'/main/rcompetitorpricecheck': 'competitor',
	'/main/rcompetitorpricecheckanalysis': 'competitor',
	'/main/rsurvey': 'survey',
	'/main/rsurveyresponse': 'survey',
	'/main/csractivity': 'survey',
	'/main/oosinsight': 'oosInsight',
	'/main/ritemdistanalysis': 'ItemDistributionReport',
	'/main/ritemdistanalysisbyagent': 'ItemDistributionReport',
	'/main/rstocknearexpiryanalysisbyitem': 'stockNearExpiryAnalysisByItem',
	'/main/rstocknearexpiryanalysisbyday': 'rstocknearexpiryanalysisbyday',
	'/main/leaves': 'leaves',
};

const POSITION_PROTECTED_ROUTES = {
	'/main/managesched': 'merchandiser',
	'/main/competitor': 'merchandiser',
	'/main/competitorgallery': 'merchandiser',
	'/main/rcompetitorpricecheck': 'merchandiser',
	'/main/rcompetitorpricecheckanalysis': 'merchandiser',
	'/main/aainsight': 'merchandiser',
	'/main/ovinsight': 'merchandiser',
	'/main/oosinsight': 'merchandiser',
	'/main/powerbiinsight': 'merchandiser',
	'/main/roos': 'merchandiser',
	'/main/routletvisit': 'merchandiser',
	'/main/rstocktake': 'merchandiser',
	'/main/rstocknearexpiry': 'merchandiser',
	'/main/rstocknearexpiryanalysis': 'merchandiser',
	'/main/rstocknearexpiryanalysisbyitem': 'merchandiser',
	'/main/rstocknearexpiryanalysisbyday': 'merchandiser',
	'/main/rposm': 'merchandiser',
	'/main/rincentive': 'merchandiser',
	'/main/rphototakenanalysis': 'merchandiser',
	'/main/ritemdistanalysis': 'merchandiser',
	'/main/ritemdistanalysisbyagent': 'merchandiser',
	'/main/rdisplay': 'merchandiser',
	'/main/rsku': 'merchandiser',
	'/main/rskustandard': 'merchandiser',
	'/main/rplacestracking': 'merchandiser',
	'/main/rsurvey': 'merchandiser',
	'/main/csractivity': 'merchandiser',
	'/main/appcontent': 'merchandiser',
	'/main/rstockcount': 'promoter',
	'/main/promoteractivitygallery': 'promoter',
};

export default function RouteWrapper({
										 component: Component,
										 isPrivate,
										 ...rest
									 }) {
	const session = JString(sessionStorage.getItem('session'));
	const signed = session.isValid();
	const [gState] = useContext(AppContext);

	if (rest.path === '/main/gallery2' && !gState.defaultPhotoGallery) {
		return <Redirect to="/main/gallery" />;
	}

	if (rest.path === '/main/gallery' && gState.defaultPhotoGallery) {
		return <Redirect to="/main/gallery2" />;
	}

	if (!signed) {
		return <Redirect to="/"/>;
	}

	// Module authorization check
	const moduleKey = MODULE_PROTECTED_ROUTES[rest.path];
	if (moduleKey) {
		if (!gState.modulesLoaded) {
			return null;
		}
		const authorizedModules = gState.authorizedModules || {};
		if (!authorizedModules[moduleKey]) {
			return <Redirect to="/main" />;
		}
	}

	// Position authorization check (additive layer; runs AFTER module check)
	const positionGate = POSITION_PROTECTED_ROUTES[rest.path];
	if (positionGate === 'merchandiser' && !isMerchandiser(gState.position)) {
		return <Redirect to="/main" />;
	}
	if (positionGate === 'promoter' && !isPromoter(gState.position)) {
		return <Redirect to="/main" />;
	}

	/*if (!isPrivate && signed) {
		return <Redirect to="/main" />;
	}*/

	return <Route {...rest} component={Component}/>;
}

RouteWrapper.propTypes = {
	isPrivate: PropTypes.bool,
	component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired
};

RouteWrapper.defaultProps = {
	isPrivate: false
};
